import { useState, useEffect } from "react";
import { db } from "../firebase/config";
import { collection, query, onSnapshot, where } from "firebase/firestore";


export const useAdmin = (user) => {
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isAdmin, setIsAdmin] = useState(null);


    useEffect(() => {
        if (!user) {
            setIsAdmin(false);
            setLoading(false);
            setError(null);
            return;
        }

        setLoading(true);
        setError(null);

        const collectionRef = collection(db, 'users');
        const q = query(
            collectionRef,
            where("id", "==", user.uid),
        );

        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const userDocument = querySnapshot.docs[0]?.data();

            setIsAdmin(Boolean(userDocument?.admin));
            setError(null);
            setLoading(false);
        }, (e) => {
            setError(e.message || "Não foi possível verificar permissão de administrador.");
            setIsAdmin(false);
            setLoading(false);
        });

        return unsubscribe;
    }, [user])

    return { isAdmin, loading, error }

}
